import React from 'react';
import { PageContainer, ComingSoon } from '@shared/components';

export const ChampionsLeagueComingSoon: React.FC = () => (
  <PageContainer>
    <ComingSoon
      title="Fantasy Champions League"
      subtitle="Fantasy Champions League is coming soon."
    />
  </PageContainer>
);
